ready(function () {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
        targetElement.focus();
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll(".sticky .anchors a");
    const sections = document.querySelectorAll(".blockAnchor");
    function updateActiveLink() {
      let currentSection = null;
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        // -- check if section is in window --
        if (rect.top <= window.innerHeight * 0.05 && rect.bottom >= window.innerHeight * 0.05) {
          currentSection = section;
        }
      });
      if (currentSection) {
        const id = currentSection.getAttribute("id");
        const activeLink = document.querySelector(`a[href="#${id}"]`);
        // -- reset anchors --
        links.forEach((lnk) => lnk.classList.add("opacity-50"));
        // -- active current anchor --
        if (activeLink) {
          activeLink.classList.remove("opacity-50");
        }
      }
    }
    window.addEventListener("scroll", updateActiveLink);
    updateActiveLink();
  });

});